// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"c85b5646","453":"19be53a6"}[chunkId] + ".chunk.js";
};